module.exports = __webpack_public_path__ + "static/media/selected.5830a946.svg";